import { getExperiment, logEvent } from './util.statsig.js'

const EXPERIMENT_NAME = 'promotion_popup'
const HIDE_GIFT_BOX_EXPERIMENT_NAME = 'hide_gift_box'
const PROMOTION_POPUP_GROUP_IDS = { old: 31, new: 32, none: 33 }
const HIDE_GIFT_BOX_GROUP_IDS = { false: 35, true: 36 }
const STORAGE_KEY_PREFIX = 'newsletter_popup_'

function recordExperimentGroup(experimentName, key, value, groupIds, unknownGroupId) {
  const groupId = groupIds[String(value)] ?? unknownGroupId
  window.zlog?.recordExperimentGroup?.(`${experimentName}:${key}`, groupId)
}

function getPopupSection() {
  return document.querySelector('.newsletter-popup--original') || document.querySelector('.newsletter-popup--v2')
}

function getDelaySeconds(el) {
  return (parseInt(el.dataset.delaySeconds, 10) || 5) * 1000
}

function getDelayDays(el) {
  return parseInt(el.dataset.delayDays, 10) || 30
}

function shouldShowPopup(sectionId, delayDays) {
  try {
    const key = STORAGE_KEY_PREFIX + sectionId
    const lastClosed = localStorage.getItem(key)
    if (!lastClosed) return true
    const daysSinceClosed = (Date.now() - parseInt(lastClosed, 10)) / (1000 * 60 * 60 * 24)
    return daysSinceClosed >= delayDays
  } catch {
    return true
  }
}

function markPopupClosed(sectionId) {
  try {
    const key = STORAGE_KEY_PREFIX + sectionId
    localStorage.setItem(key, String(Date.now()))
  } catch {}
}

function showOriginalPopup(sectionEl) {
  const popup = sectionEl.closest('.newsletter-popup--original') || document.querySelector('.newsletter-popup--original')
  if (!popup) return

  const sectionId = popup.dataset.sectionId
  const delayDays = getDelayDays(popup)
  const delayMs = getDelaySeconds(popup)

  popup.querySelectorAll('.js-modal-close').forEach((btn) => {
    btn.addEventListener('click', () => {
      popup.classList.remove('modal--is-active')
      popup.style.display = 'none'
      markPopupClosed(sectionId)
      showOriginalReminder()
    })
  })

  initOriginalReminder(popup)

  if (!shouldShowPopup(sectionId, delayDays)) {
    showOriginalReminder()
    return
  }

  setTimeout(() => {
    popup.style.display = ''
    popup.classList.add('modal--is-active')
  }, delayMs)
}

function initOriginalReminder(popup) {
  const wrapper = document.querySelector('.newsletter-reminder--original')
  if (!wrapper) return

  const reminder = wrapper.querySelector('newsletter-reminder')
  if (reminder) {
    reminder.addEventListener('click', () => {
      wrapper.style.display = 'none'
      if (popup) {
        popup.style.display = ''
        popup.classList.add('modal--is-active')
      }
    })
  }
}

function showOriginalReminder() {
  const wrapper = document.querySelector('.newsletter-reminder--original')
  if (!wrapper) return
  wrapper.style.display = ''
  const reminder = wrapper.querySelector('newsletter-reminder')
  if (reminder) {
    reminder.dataset.enabled = 'true'
  }
}

function showV2Popup(hideGiftBox = false) {
  const popup = document.querySelector('.newsletter-popup--v2')
  if (!popup) return

  const sectionId = popup.dataset.sectionId
  const delayDays = getDelayDays(popup)
  const delayMs = getDelaySeconds(popup)

  const closePopup = () => {
    popup.style.display = 'none'
    markPopupClosed(sectionId)
    if (!hideGiftBox) {
      showV2Reminder()
    }
  }

  popup.addEventListener('click', (e) => {
    if (e.target.closest('.newsletter-popup-v2__close') || e.target.closest('.newsletter-popup-v2__overlay')) {
      closePopup()
    }
  })

  if (!hideGiftBox) {
    initV2Reminder(popup)
  }

  if (popup.querySelector('.newsletter-v2-form-success')) {
    markPopupClosed(sectionId)
    if (window.toast) window.toast('🎁 Thanks for subscribing！')
    return
  }

  if (popup.querySelector('.newsletter-v2-form-error')) {
    if (window.toast) window.toast('Login failed. Please try again.')
    return
  }

  if (!shouldShowPopup(sectionId, delayDays)) {
    if (!hideGiftBox) {
      showV2Reminder()
    }
    return
  }

  // 命中 hide_gift_box 实验组时立即展示，否则按配置延时展示
  if (hideGiftBox) {
    popup.style.display = 'block'
  } else {
    setTimeout(() => {
      popup.style.display = 'block'
    }, delayMs)
  }
}

function initV2Reminder(popup) {
  const wrapper = document.querySelector('.newsletter-reminder--v2')
  if (!wrapper) return

  const reminder = wrapper.querySelector('newsletter-reminder')
  if (reminder) {
    reminder.addEventListener('click', () => {
      if (reminder._wasDragged) {
        reminder._wasDragged = false
        return
      }
      wrapper.style.display = 'none'
      if (popup) popup.style.display = 'block'
    })
  }

  const closeBtn = wrapper.querySelector('.newsletter-reminder-v2__close')
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      wrapper.style.display = 'none'
    })
  }
}

function showV2Reminder() {
  const wrapper = document.querySelector('.newsletter-reminder--v2')
  if (!wrapper) return
  wrapper.style.display = ''
  const reminder = wrapper.querySelector('newsletter-reminder')
  if (reminder) {
    reminder.dataset.enabled = 'true'
  }
}

async function initPopupAbTest() {
  const sectionEl = getPopupSection()
  if (!sectionEl) return

  let group = 'old'
  let hideGiftBox = false
  try {
    const experiment = await getExperiment(EXPERIMENT_NAME)
    group = experiment.get('mode', 'old')
    recordExperimentGroup(EXPERIMENT_NAME, 'mode', group, PROMOTION_POPUP_GROUP_IDS, 34)

    // 读取 hide_gift_box 实验：Control=false，Test=true，异常默认 false
    try {
      const hideGiftBoxExp = await getExperiment(HIDE_GIFT_BOX_EXPERIMENT_NAME)
      hideGiftBox = hideGiftBoxExp.get('enable', false) === true
      recordExperimentGroup(
        HIDE_GIFT_BOX_EXPERIMENT_NAME,
        'enable',
        hideGiftBox,
        HIDE_GIFT_BOX_GROUP_IDS,
        37,
      )
    } catch {
      hideGiftBox = false
    }
  } catch {
    group = 'old'
    hideGiftBox = false
  }

  logEvent('promotion_popup_exposure', null, { group, hide_gift_box: hideGiftBox })

  if (group === 'none') {
    return
  }

  if (group === 'new') {
    showV2Popup(hideGiftBox)
  } else {
    showOriginalPopup(sectionEl)
  }
}

initPopupAbTest()
